module.exports = __webpack_public_path__ + "img/recipe_default.8b76b6e6.jpg";